import { Tag, Tooltip, Button } from 'antd'
import { CheckCircle2, AlertCircle, Clock, RefreshCw } from 'lucide-react'
import { useState } from 'react'
import { timeAgo } from '@/lib/utils'

type Status = 'success' | 'warning' | 'danger' | 'idle'

interface ScrapeStatusInfo {
  status: Status
  lastRunAt: number
  message?: string
  queueTasks?: number
  dataGapDays?: number
}

interface Props {
  status?: ScrapeStatusInfo
  onRefresh?: () => void
}

const defaultStatus: ScrapeStatusInfo = {
  status: 'success',
  lastRunAt: Date.now() - 1000 * 60 * 60 * 3, // 3 小时前
  message: '增量抓取完成 5 个面板',
}

export default function ScrapeStatus({ status = defaultStatus, onRefresh }: Props) {
  const [refreshing, setRefreshing] = useState(false)

  const config = {
    success: { icon: <CheckCircle2 size={14} />, color: 'success', text: '正常' },
    warning: { icon: <Clock size={14} />, color: 'warning', text: '需关注' },
    danger: { icon: <AlertCircle size={14} />, color: 'error', text: '需重新扫码' },
    idle: { icon: <Clock size={14} />, color: 'default', text: '未运行' },
  }[status.status]

  const handleRefresh = async () => {
    setRefreshing(true)
    try {
      await onRefresh?.()
    } finally {
      setTimeout(() => setRefreshing(false), 1000)
    }
  }

  return (
    <Tooltip
      title={
        <div>
          <div>最后抓取：{timeAgo(status.lastRunAt)}</div>
          {status.message && <div className="text-xs opacity-80 mt-1">{status.message}</div>}
        </div>
      }
    >
      <div className="flex items-center gap-2 px-2.5 py-1 rounded-md hover:bg-ink-50 transition-colors">
        <Tag
          color={config.color}
          icon={config.icon}
          className="!flex !items-center !gap-1 !mr-0"
        >
          抓取 {config.text}
        </Tag>
        <Button
          type="text"
          size="small"
          icon={<RefreshCw size={12} className={refreshing ? 'animate-spin' : ''} />}
          onClick={handleRefresh}
          className="!text-ink-500"
        />
      </div>
    </Tooltip>
  )
}
